import { createSelector } from "reselect";
import { ListFieldsKeys } from "src/api/config";
import { RootState } from "src/store/rootReducer";

const getNextPage = (state: RootState, listName: ListFieldsKeys) => {
  return state.spitems.elements.nextPage[listName];
};

export const selectNextPage = createSelector(getNextPage, (nextPage) => {
  if (nextPage) {
    return nextPage;
  } else {
    return null;
  }
});
